import Vue from 'vue';

export default [
    {
        pathId: 'aps',
        component: 'applications',
        title: 'Applications',
        icon: 'fa-file-certificate',
        size: 'sm',
        loading: true
    }, {
        pathId: 'apn',
        component: 'new-application',
        title: 'New Application',
        icon: 'fa-plus',
        size: 'md'
    }, {
        pathId: 'ap',
        component: 'application',
        title: 'Application',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['applicationId'],
        loading: true
    },  {
        pathId: 'ape',
        component: 'edit-application',
        title: 'Edit Application',
        icon: 'fa-pencil',
        size: 'md',
        props: ['applicationId'],
        loading: true
    }, {
        pathId: 'apcn',
        component: 'new-application-component',
        title: 'New Application Component',
        icon: 'fa-plus',
        size: 'md',
        props: ['applicationId']
    }, {
        pathId: 'apas',
        component: 'application-applicants',
        title: 'Application Applicants',
        icon: 'fa-users',
        size: 'md',
        props: ['applicationId'],
        loading: true
    }, {
        pathId: 'apa',
        component: 'application-applicant',
        title: 'Application Details',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['applicationId', 'applicantType', 'applicantId'],
        loading: true
    }
];

Vue.component('applications', () => import('@/cards/applications/Applications'));
Vue.component('new-application', () => import('@/cards/applications/NewApplication'));
Vue.component('application', () => import('@/cards/applications/Application'));
Vue.component('edit-application', () => import('@/cards/applications/EditApplication'));
Vue.component('new-application-component', () => import('@/cards/applications/NewComponent'));
Vue.component('application-applicants', () => import('@/cards/applications/applicants/Applicants'));
Vue.component('application-applicant', () => import('@/cards/applications/applicants/Applicant'));
